'use strict';
var dataTables

$.ajaxSetup({
  beforeSend: function(xhr, settings) {
      if (!settings.crossDomain && window.currentCspNonce) {
          xhr.setRequestHeader("x-dcs-csp-nonce", window.currentCspNonce)
      }
  }
});

$('[data-submit-form]').click(function () {
    var targetId = $(this).data('submit-form');
    var $target = $('#' + targetId);
    if ($target.length < 1) {
        Sentry.captureMessage("Failed to find data-submit-form=" + targetId)
    }
    if ($target.length > 1) {
        Sentry.captureMessage("Expected to find exactly one data-submit-form=" + targetId)
    }
    $target.submit();
});

$(document).on('click', '[data-click-button]', function () {
    var targetId = $(this).data('click-button');
    var scrollIntoView = $(this).data('scroll-into-view') !== undefined;
    var $target = $('#' + targetId);
    if ($target.length < 1) {
        Sentry.captureMessage("Failed to find data-click-button=" + targetId)
    }
    if ($target.length > 1) {
        Sentry.captureMessage("Expected to find exactly one data-click-button=" + targetId)
    }
    $target.click();
    if (scrollIntoView)
        $target[0].scrollIntoView()
});

$(document).on('click', '[data-copy-to-clipboard-button]', function () {
    var targetId = $(this).data('copy-to-clipboard-button');
    var $target = $('#' + targetId);
    $target.select();
    document.execCommand("copy");
});

$(document).on('change', '[data-submit-on-change]', function () {
    $(this).parents('form').submit();
});

$(document).on('change', '.js-select-link', function () {
    window.location = this.value;
});

$(document).on('click', '.js-link', function () {
    var href = $(this).data('href');
    if (href)
        window.location = href;
})

$(document).on('change', '.js-smart-admin-file-widget input', function () {
    this.parentNode.nextSibling.value = this.value;
});

$('[data-show-when-checked]').each(function () {
    var $elem = $(this),
        $target = $('#' + $elem.data('show-when-checked'));
    $target.change(function (e) {
        $elem.toggleClass('hidden', !e.target.checked);
    });
    $elem.toggleClass('hidden', !$target[0].checked);
});

function runActivatorsIn(topElement) {
    var $container = $(topElement)

    $container.find('[data-hide-when-checked]').each(function () {
        var $elem = $(this),
            target_selector ='#' + $elem.data('hide-when-checked'),
            $target = $( target_selector);
        if (!$elem.data('hide-when-checked-initialized')) {
            $elem.data('hide-when-checked-initialized', true);

            $target.change(function (e) {
                $elem.toggleClass('hidden', e.target.checked);
            });
            if ($target.length > 0) {
                $elem.toggleClass('hidden', $target[0].checked);
            } else {
                Sentry.captureMessage(`data-hide-when-checked: Failed to find ${target_selector}`)
                console.error(`data-hide-when-checked: Failed to find ${target_selector}`, {$elem})
            }
        }
    });
}
runActivatorsIn(document);

$(document).on('loaded.bs.modal', function (e) {
    runActivatorsIn(e.target);
})

// modal-open dla zagnieżdżonych modali {
var bsModalCount = 0;
$(document).on('show.bs.modal', function (event) {
    if (!event.target.dataset.dontCountAsModal)
        bsModalCount += 1;
    $('body').toggleClass('modal-open', bsModalCount > 0);
})
$(document).on('hidden.bs.modal', function (event) {
    if (!event.target.dataset.dontCountAsModal)
        bsModalCount -= 1;
    $('body').toggleClass('modal-open', bsModalCount > 0);
})
// }

$(document).on('hide.bs.modal', function () {
    $(this).find('.js-needs-destroy').trigger('weekly:deactivate-elem');
})
$(document).on('hidden.bs.modal', function () {
    $(this).find('.js-needs-destroy').trigger('weekly:destroy-elem');
})

$(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function () {
    // Czyszczenie modala ładowanego z URLa.
    if ($(this).is('a[href]')) {
        var target = $(this).data('target');
        var $target = $(target);
        $target.on('hidden.bs.modal', function () {
            var content = $target.find('.modal-content');
            content.html('');
        })
    }
})

$('.modal:not(.question-modal)').on('show.bs.modal', function () {
   // $(this).appendTo($('body'));
})

$('.modal').on('shown.bs.modal', function() {
  $(this).find('[autofocus]').focus();
});

$(document).on('submit', '.ajax-form', function (e) {
    var form = $(this);
    var disableOnSubmit = form.data('disable-on-submit');
    var extraData = {};
    var elementsToEnableAfterSubmit = $();
    var elementsToRemoveAfterSubmit = $();
    if (e.isDefaultPrevented())
        return;
    if (e.originalEvent && e.originalEvent.submitter) {
        // submitter to kliknięty przycisk
        if (e.originalEvent.submitter.name && e.originalEvent.submitter.value) {
            extraData[e.originalEvent.submitter.name] = e.originalEvent.submitter.value;
        }
    }

    if (disableOnSubmit) {
        elementsToEnableAfterSubmit = form.find('button:not(:disabled)');
        elementsToEnableAfterSubmit.attr('disabled', true);
        elementsToRemoveAfterSubmit = $(
            `<div class="spinner-overlay"><i class="fa fa-cog fa-4x spinner-overlay__spinner" aria-hidden="true"><span class="sr-only">Processing, please wait</span></i></div>`
        ).appendTo(form);
    }

    var options = {
        data: extraData,
        complete: function () {
            elementsToEnableAfterSubmit.attr('disabled', false);
            elementsToRemoveAfterSubmit.remove();
        },
        error: function (response) {
            if (response.status === 403 || response.status === 400) {
                var event = $.Event('ajaxForm:error', {});
                form.trigger(event);
                var replace = form.data('ajax-form-replace') || '.modal-base';
                var $replace = form.closest(replace);
                if ($replace.length === 0)
                    console.error("Couldn't find ajax-form-replace target", replace);
                $replace.replaceWith(response.responseJSON.content);
            }
        },
        success: function (data) {
            var event = $.Event('ajaxForm:submitted', {responseData: data});
            form.trigger(event);
            if (event.isDefaultPrevented())
                return;

            if (data.action === 'refresh') {
                window.location.reload();
            }
            if (data.action === 'redirect') {
                var redirectContainer = $('.ajax-form-redirect-container').last()
                if (redirectContainer.length > 0) {
                    redirectContainer.load(data.url)
                    return;
                }
                var url_elements = data.url.split("#");
                if ((url_elements.length === 1) || window.location.pathname !== url_elements[0]) {
                    window.location.assign(data.url);
                } else {
                    // append hash and reload
                    window.location.hash = url_elements[1];
                    window.location.reload();
                }
            }
        }
    }
    form.ajaxSubmit(options)
    return false;
});

$(document).on('click', '.js-delete', function (event) {
    var $button = $(this);
    var deleteUrl = $button.data('deleteUrl');
    var deleteMessage = $button.data('deleteMessage');
    var removeParent = $button.data('removeParent');
    var removeElements = $button.data('removeElements');
    var hideElements = $button.data('hideElements');
    var refreshOnSuccess = $button.data('refreshOnSuccess');
    var disableTheButton = !$button.attr("disabled");

    event.preventDefault();

    $.SmartMessageBox({
        'title': deleteMessage,
        'buttons': '[' + gettext('No') + '][' + gettext('Yes') + ']'
    }, function (button) {
        if (button === gettext('Yes')) {
            if (disableTheButton)
                $button.attr('disabled', true);

            $.post(deleteUrl, function () {
                if (removeParent)
                    $button.parents(removeParent).remove();
                if (removeElements)
                    $(removeElements).remove();
                if (hideElements)
                    $(hideElements).hide();
                if (refreshOnSuccess)
                    window.location.reload();
            }).always(function () {
                if (disableTheButton)
                    $button.attr('disabled', false);
            });
        }
        return true;
    });
})

var responsiveHelper_dt_basic = undefined;

var breakpointDefinition = {
    tablet : 1024,
    phone : 480
};

jQuery.fn.dataTableExt.oSort['status-asc']  = function(x,y) {
    return ((x < y) ? -1 : ((x > y) ?  1 : 0));
};

jQuery.fn.dataTableExt.oSort['status-desc']  = function(x,y) {
    return ((x < y) ? 1 : ((x > y) ?  -1 : 0));
};

datatablesLangPl['sLengthMenu'] = '_MENU_&nbsp;';

const baseDataTableSettings = {
    "sDom": "t"+
    "<'dt-toolbar-footer'<'col-sm-6 col-xs-12 hidden-xs'i><'col-xs-12 col-sm-6'<p><l><r>>>",
       "autoWidth" : false,
       "preDrawCallback" : function() {
           // Initialize the responsive datatables helper once.
           if (!responsiveHelper_dt_basic) {
               responsiveHelper_dt_basic = new ResponsiveDatatablesHelper($('.dataTable'), breakpointDefinition);
           }
       },
       "rowCallback" : function(nRow) {
           responsiveHelper_dt_basic.createExpandIcon(nRow);
       },
       "drawCallback" : function(oSettings) {
           responsiveHelper_dt_basic.respond();
           $(".dataTable .easy-pie-chart").each(function(){
               var a=$(this),
                   b=a.css("color") || a.data("pie-color"),
                   c=a.data("pie-track-color") || "rgba(0,0,0,0.04)",
                   d=parseInt(a.data("pie-size")) || 25;
                   a.easyPieChart({
                        "barColor":b,
                        "trackColor":c,
                        "scaleColor":!1,
                        "lineCap":"butt",
                        "lineWidth":parseInt(d/8.5),
                        "animate":1500,
                        "rotate":-90,
                        "size":d,
                        "onStep": function(a,b,c){
                            $(this.el).find(".percent").text(Math.round(c))
                        }
                   }),a=null})
       },
       language: datatablesLang,
       order: [],
       aoColumnDefs: [
        { "sType": "status", "aTargets": ["status"]},
        { "bSortable": false, "aTargets": ['nosort']}
       ]
}

const dataTableSettings = $.extend({}, baseDataTableSettings);
const noSearchDataTableSettings = $.extend({}, baseDataTableSettings, {
    searching: false,
})
const ajaxDataTableSettings = $.extend({}, baseDataTableSettings, {
    'serverSide': true,
    'ajax': function(data, callback, settings) {
        var instance = settings.oInstance;
        var url = instance.data('url')
        $.get(url, data, callback);
    }
});

var Debouncer = function (time) {
    this._time = time;
    this._timeoutId = undefined;
};
Debouncer.prototype.run = function (fun) {
    clearTimeout(this._timeoutId);
    this._timeoutId = setTimeout(fun, this._time);
};

var dtRenderText = function (data) {
    if (typeof(data) === "string") {
        return data.replace(/</g, "&lt;");
    }
    return data;
};

// Mamy starą wersję DataTables, nie ma jeszcze eventu na błędy.
$.fn.DataTable.ext.errMode = "alert";
function _custom_alert(message) {
    if (message && typeof message === "string" && message.startsWith("DataTables")) {
        Sentry.captureMessage('DataTables alert: ' + message)
    }
    _custom_alert.__original__.apply(this, arguments)
}
_custom_alert.__original__ = window.alert
window.alert = _custom_alert

$('.dataTable').each(function () {
    var paging = this.dataset.paging !== "false";
    $(this).DataTable(Object.assign({}, dataTableSettings, {
        "bPaginate": paging,
    }));
}).each(function () {
    enableDataTableFilters($(this), {debounce: 100});
});

$('.noSearchDataTable').each(function () {
    var $this = $(this);
    var options = {};
    $.extend(options, noSearchDataTableSettings, $this.data());
    if (options.paging === false)
        // Drop the whole footer
        options.sDom = options.sDom.replace(/<'dt-toolbar-footer'.*/, '');
    $this.DataTable(options);
});

window.initializeAjaxDataTable = function initializeAjaxDataTable($table) {
    var settings = $.extend({}, ajaxDataTableSettings);
    var columns = [], order = [];
    $table.find('.header th').each(function () {
        var column = {
            'data': $(this).data('column'),
            'className': $(this).data('class-name'),
        };
        if (!$(this).data('html-safe')) {
            column.render = dtRenderText;
        }
        if ($(this).data('default-order')) {
            order.push([columns.length, $(this).data('default-order')]);
        }
        columns.push(column);
    });
    var language =  $table.data('language');
    if (typeof language === 'object') {
        settings.language = $.extend({}, settings.language, language);
    }
    settings.columns = columns;
    settings.order = order;
    $table.DataTable(settings);
    enableDataTableFilters($table, {debounce: 250});
}

function enableDataTableFilters($table, options) {
    // Filters support
    var filterDebouncer = new Debouncer(options.debounce);

    $("thead .hasinput input[type=text], thead .hasinput select", $table).on('keyup change', function () {
        var $input = $(this),
            dt = $input.parents('table').DataTable(),
            $column = $(this).parents('.hasinput'),
            columnIndex = $column.prevAll().toArray().reduce(function (acc, e) {
                return acc + (e.colSpan || 1)
            }, 0);
        if (!$input.val())
            $input.addClass('empty')
        else
            $input.removeClass('empty')
        filterDebouncer.run(function () {
            dt.column(columnIndex + ':visible')
                .search($input.val())
                .draw();
        });
    });
}

$('.ajax-dataTable').each(function () {
    initializeAjaxDataTable($(this))
});

function initializeCharacterCounter(elem) {
    var $container = $(elem);
    var $input = $('#' + $container.data('counterFor'));
    var maxLength = $input.attr('maxlength');
    if (!maxLength) {
        console.warn("initializeCharacterCounter: brak maxlength na ", $container.data('counterFor'), $input)
        return
    }
    $input.attr('maxlength', null);

    var eventHasChar = function (e) {
        if (typeof(e.char) != 'undefined') return e.char.length > 0;
        if (e.ctrlKey) return false;
        return e.charCode != 0 || e.keyCode == 13;
    };

    var lockMax = function (e) {
        var newCharsLen;
        if (e.type == "paste") {
            var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
            var pasted = clipboardData.getData('Text');
            newCharsLen = pasted.length;
        } else if (e.type == "keypress" && eventHasChar(e)) {
            newCharsLen = 1;
        } else {
            return true;
        }
        if (e.target.value.length + newCharsLen > maxLength) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
    };
    var updateCounter = function () {
        setTimeout(function () { $container.html($input.val().length + ' / ' + maxLength); }, 1);
    };
    $input.on('keypress paste', lockMax);
    $input.on('keydown paste', updateCounter);
    updateCounter();
}
$('.character-counter').each(function () {
    initializeCharacterCounter(this)
})

window.initializeCharacterCounter = initializeCharacterCounter;

$(document).on('click', '.custom-jarviswidget-toggle-btn', function (e) {
    var content = $(this).closest('.jarviswidget').find('[role=content]')
    if (content.is(':visible')) {
        content.slideUp(200)
        $(this).find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
    } else {
        content.slideDown(200)
        $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
    }
    e.preventDefault();
});


$(document).on('click', '.custom-jarviswidget-edit-btn', function (e) {
    var content = $(this).closest('.jarviswidget').find('[role=help]')
    if (content.is(':visible')) {
        content.slideUp(200)
    } else {
        content.slideDown(200)
    }
    e.preventDefault();
});

var widgets = '.jarviswidget',
    fullscreenClass = ['fullscreen-10', 'normalscreen-10'],
    pwCtrls = '.jarviswidget-ctrls';

function heightFullscreen() {
    if ($('#jarviswidget-fullscreen-mode').length) {
        var heightWindow = $(window).height();
        var heightHeader = $('#jarviswidget-fullscreen-mode')
            .children(widgets)
            .children('header')
            .height();

        $('#jarviswidget-fullscreen-mode')
            .children(widgets)
            .children('div')
            .height(heightWindow - heightHeader - 15);
    }
}

$(document).on('click', '.jarviswidget-fullscreen-btn', function (e) {
    var thisWidget = $(this).parents(widgets);
    var thisWidgetContent = thisWidget.children('div');
    if ($('#jarviswidget-fullscreen-mode').length) {

        $('.nooverflow').removeClass('nooverflow');

        thisWidget.unwrap('div')
            .children('div')
            .removeAttr('style')
            .end()
            .find('.jarviswidget-fullscreen-btn:first')
            .children()
            .removeClass(fullscreenClass[1])
            .addClass(fullscreenClass[0])
            .parents(pwCtrls)
            .children('a')
            .show();

        if (thisWidgetContent.hasClass('jarviswidget-visible')) {
            thisWidgetContent.hide().removeClass('jarviswidget-visible');
        }

    } else {

        $('body').addClass('nooverflow');

        thisWidget.wrap('<div id="jarviswidget-fullscreen-mode"/>')
            .parent()
            .find('.jarviswidget-fullscreen-btn:first')
            .children()
            .removeClass(fullscreenClass[0])
            .addClass(fullscreenClass[1])
            .parents(pwCtrls)
            .children('a:not(.jarviswidget-fullscreen-btn)')
            .hide();

        if (thisWidgetContent.is(':hidden')) {
            thisWidgetContent.show()
                .addClass('jarviswidget-visible');
        }
    }

    heightFullscreen();
    e.preventDefault();
});

$(document).on('click', '.js-create-folder', function (e) {
    if (e.defaultPrevented) return;
    var $target = $(e.currentTarget);
    $.createFolder({
        parent: $target.data('parent'),
        createFolderUrl: $target.data('createFolderUrl'),
        context: $target.data('context'),
    }, function (data) {
        window.location.href = data.folderUrl;
    })
});

$(document).on('click', '.js-edit-folder', function (e) {
    if (e.defaultPrevented) return;
    var $target = $(e.currentTarget);
    $.editFolder({
        name: $target.data('name'),
        updateUrl: $target.data('updateUrl'),
        context: $target.data('context'),
    }, function (data) {
        window.location.href = data.folderUrl;
    })
});

$(document).on('click', '.js-remove-folder', function (e) {
    if (e.defaultPrevented) return;
    var $button = $(e.currentTarget);
    var deleteUrl = $button.data('remove-folder-url');

    $.SmartMessageBox({
        'title': gettext('Do you really want to delete this folder?'),
        'buttons': `[${gettext('No')}][${gettext('Yes')}]`,
    }, function (button) {
        if (button === gettext('Yes')) {
            $.post(deleteUrl, function (data) {
                window.location.href = data.url;
            });
        }
        return true;
    });
})

window.openSmartMessageBoxConfirmation = function openSmartMessageBoxConfirmation(title, yesCallback) {
    $.SmartMessageBox({
        'title': title,
        'buttons': `[${escapeButtonName(gettext('No'))}][${escapeButtonName(gettext('Yes'))}]`,
    }, function (button) {
        if (button === gettext('Yes')) {
            yesCallback();
        }
        return true;
    });
}

window.initializeColorPickers = function initializeColorPickers($form) {
    $($form || 'body').find('.colorpicker-component').each(function () {
        initializeColorPickerByElem($(this))
    });
}

window.initializeColorPickerByElem = function initializeColorPickerByElem($pickerComponent) {
    var $picker = $pickerComponent.find("input").first();
    $picker.colorpicker();
    $picker.on('changeColor', updatePicker);
    $picker.on('hide', function (event) {
        $picker.trigger('change', event);
    });
    $picker.on('blur', function () {
        $picker.colorpicker("hide")
    })
    updatePicker();

    function updatePicker() {
        var value = $picker.data('colorpicker').color.toHex();
        $picker.siblings('.input-group-addon').find('i').css({backgroundColor: value});
        $picker.val(value);
    }
}

$(window).on('resize', function () {
    heightFullscreen();
});

/***
 * Prosty system reagowania na zmiany.
 * Uruchamia connect, potem update(), i po każdym wywołaniu handler() znów uruchamia update()
 *
 * @template State
 * @param {(handler: () => undefined) => State} connect Funkcja rejestrująca uchwyty
 * @param {(state: State, updateState: ((newState: State) => undefined)) => undefined} update Funkcja wczytująca stan i aktualizująca DOM
 */
window.watcher = function watcher(connect, update) {
    var watcher = {
        state: null,
        reconnect: function reconnect() {
            var handleChange = watcher.render;
            watcher.state = connect(handleChange)
            watcher.render()
        },
        update: function updateWatcher(newState) {
            if (typeof watcher.state === 'object' && typeof newState === 'object') {
                watcher.state = Object.assign({}, watcher.state, newState)
            } else {
                watcher.state = newState
            }
        },
        render: function renderWatcher() {
            update(watcher.state, watcher.update)
        },
    }
    watcher.reconnect()
    return watcher
}

window.escapeButtonName = function escapeButtonName(raw) {
    return raw.replaceAll('[', '&lsqb;').replaceAll(']', '&rsqb;');
}



// WEBPACK FOOTER //
// ./weekly/static/js/activators.js